/**
 * Standing weekly commitments — the blocks the planner has to work around.
 */
import { api } from '@/convex/_generated/api'
import type { Doc, Id } from '@/convex/_generated/dataModel'
import { convex, whenConvexReady } from '@/lib/convex-client'

export type Commitment = Doc<'commitments'>

export async function listCommitments(): Promise<Commitment[]> {
  await whenConvexReady()
  return await convex.query(api.commitments.list, {})
}

export async function createCommitment(input: {
  label: string
  weekdays: number[]
  startMinutes: number
  endMinutes: number
}): Promise<Commitment> {
  await whenConvexReady()
  return await convex.mutation(api.commitments.create, input)
}

export async function setCommitmentActive(id: string, active: boolean): Promise<void> {
  await whenConvexReady()
  await convex.mutation(api.commitments.setActive, {
    commitmentId: id as Id<'commitments'>,
    active,
  })
}

export async function removeCommitment(id: string): Promise<void> {
  await whenConvexReady()
  await convex.mutation(api.commitments.remove, {
    commitmentId: id as Id<'commitments'>,
  })
}

/** `"09:30"` → 570. Returns null when the value isn't a time. */
export function timeToMinutes(value: string): number | null {
  const match = value.match(/^(\d{1,2}):(\d{2})$/)
  if (!match) return null
  const hours = Number(match[1])
  const minutes = Number(match[2])
  if (hours > 23 || minutes > 59) return null
  return hours * 60 + minutes
}

/** 570 → `"09:30"`. */
export function minutesToTime(minutes: number): string {
  const hours = Math.floor(minutes / 60) % 24
  return `${String(hours).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`
}
